import {Router} from './routing/router';
import {ToastProvider} from './toaster/toaster';

export const App = (): React.JSX.Element => (
    <ToastProvider>
        <Router />
    </ToastProvider>
);
